import React, { useEffect, useState } from "react";
import TableOuterLabelMarkStatus from "../../../components/Table/TableOuterLabelMarkStatus";
import Table from "../../../components/Table/Table";
import AssignmentMarkListTr from "./AssignmentMarkListTr";
import Loading from "../../../components/Ui/Loading";
import Error from "../../../components/Ui/Error";
import {
  useEditAssignmentMarkMutation,
  useGetAssignmentsMarkQuery,
} from "../../../features/Admin/AssignmentsMark/assignmentsMarkApi";
import { useDispatch } from "react-redux";
import { markBatch } from "../../../features/Admin/AssignmentsMark/assignmentsMarkSlice";

const headers = ["Assignment", "Date", "Student Name", "Repo Link", "Mark"];
export default function AssignmentMark() {
  // *****************************************************DECLARATION START******************************************************************************
  const dispatch = useDispatch();
  const {
    data: assignmentsMark,
    isLoading,
    isSuccess,
    isError,
  } = useGetAssignmentsMarkQuery() || {};
  const [
    editAssignmentMark,
    { isSuccess: editAsgMarkIsSuccess, isError: editAsgMarkIsError },
  ] = useEditAssignmentMarkMutation();

  const [markValue, setMarkValue] = useState("");
  // *****************************************************DECLARATION END******************************************************************************
  // *****************************************************useEffect END******************************************************************************
  useEffect(() => {
    const totalAsn = assignmentsMark?.length;
    const { pendingCount, publishedCount } =
      assignmentsMark?.length > 0 &&
      assignmentsMark.reduce(
        (acc, { status }) => {
          if (status === "pending") acc.pendingCount++;
          if (status === "published") acc.publishedCount++;
          return acc;
        },
        { pendingCount: 0, publishedCount: 0 }
      );
    if (isSuccess || editAsgMarkIsSuccess) {
      dispatch(
        markBatch({
          total: totalAsn,
          pending: pendingCount,
          sent: publishedCount,
        })
      );
    }
  }, [dispatch, isSuccess, editAsgMarkIsSuccess, assignmentsMark, markValue]);
  // *****************************************************useEffect END******************************************************************************

  // *****************************************************HANDLE START******************************************************************************

  const handleInputChange = (e, id) => {
    let matchId = assignmentsMark.find((a) => a.id === id);
    const { totalMark } = matchId;
    const { value } = e.target;
    // Use regex to validate input
    const regExp = new RegExp(`^([0-9]|[1-9][0-9]|${+totalMark})$`);
    const validInput = regExp.test(value);

    if (validInput) {
      setMarkValue(value);
    } else {
      alert(`Please enter valid mark 0 to ${totalMark}!!`);
      setMarkValue("");
    }
  };
  const handleMark = (id) => {
    let matchId = assignmentsMark.find((a) => a.id === id);
    let ChangeStatus =
      markValue === ""
        ? "pending"
        : markValue >= 0 && markValue <= matchId?.totalMark
        ? "published"
        : "pending";
    editAssignmentMark({
      data: {
        mark: +markValue,
        status: ChangeStatus,
      },
      id: id,
    });
    // setMarkValue(""); // reset mark input value
  };
  // *****************************************************HANDLE END******************************************************************************

  // *****************************************************Decided which part render START******************************************************************************

  let content = null;
  let contentLoadingOrError = null;
  if (isLoading) {
    contentLoadingOrError = <Loading />;
  } else if (!isLoading && (isError || editAsgMarkIsError)) {
    contentLoadingOrError = (
      <Error
        header="Error !!"
        message="System error contact with administrator"
      />
    );
  } else if (!isLoading && !isError && assignmentsMark?.length === 0) {
    contentLoadingOrError = (
      <Error header="" message="No assignment Mark available" />
    );
  } else if (!isLoading && !isError && assignmentsMark?.length > 0) {
    content = assignmentsMark.map((row, index) => (
      <AssignmentMarkListTr
        key={`${row?.id}_${index}`}
        row={row}
        markValue={markValue}
        handleInputChange={handleInputChange}
        handleMark={handleMark}
      />
    ));
  }
  content = contentLoadingOrError ? (
    contentLoadingOrError
  ) : (
    <Table headers={headers}>{content}</Table>
  );
  // *****************************************************Decided which part render END******************************************************************************

  return (
    <>
      <TableOuterLabelMarkStatus />
      <div className="overflow-x-auto mt-4">{content}</div>
    </>
  );
}
